import {
    Boxes,
    CalendarClock,
    Factory,
    LayoutDashboard,
    Package,
    Smartphone,
    Tags,
    UserCircle2,
    UserCog,
    Users,
    Wallet,
} from "lucide-react";
import React from "react";
import { Role } from "../../types";

export interface NavItem {
    label: string;
    to: string;
    icon: React.ElementType;
    roles: Role[];
}

export interface NavGroup {
    title: string;
    items: NavItem[];
}

const STAFF: Role[] = ["SUPERADMIN", "RESELLER"];
const ADMIN: Role[] = ["SUPERADMIN"];
const ALL: Role[] = ["SUPERADMIN", "RESELLER", "DEVELOPER", "USER"];

export const NAV_GROUPS: NavGroup[] = [
    {
        title: "Overview",
        items: [{ label: "Dashboard", to: "/dashboard", icon: LayoutDashboard, roles: STAFF }],
    },
    {
        title: "CRM",
        items: [
            { label: "Customers", to: "/customers", icon: Users, roles: STAFF },
            { label: "Customer Products", to: "/customer-products", icon: Package, roles: STAFF },
            { label: "Renewals", to: "/renewals", icon: CalendarClock, roles: STAFF },
        ],
    },
    {
        title: "Catalog",
        items: [
            { label: "Products", to: "/products", icon: Boxes, roles: ADMIN },
            { label: "Categories", to: "/settings/categories", icon: Tags, roles: ADMIN },
            { label: "Manufacturers", to: "/settings/manufacturers", icon: Factory, roles: ADMIN },
            { label: "Device Types", to: "/settings/device-types", icon: Smartphone, roles: ADMIN },
            { label: "Subscription Plans", to: "/settings/plans", icon: Wallet, roles: ADMIN },
        ],
    },
    {
        title: "Admin",
        items: [{ label: "Users", to: "/users", icon: UserCog, roles: ADMIN }],
    },
    {
        title: "Account",
        items: [{ label: "Profile", to: "/profile", icon: UserCircle2, roles: ALL }],
    },
];

/** Groups/items the role can see (empty groups removed) */
export const navFor = (role: Role | undefined): NavGroup[] =>
    NAV_GROUPS.map((g) => ({ ...g, items: g.items.filter((i) => role && i.roles.includes(role)) })).filter(
        (g) => g.items.length > 0
    );